// Ajout des variables globales pour leafletParams et L
window.leafletParams = window.leafletParams || {};
window.L = window.L || undefined;

export default class UnepMap {

    constructor() {
        this.baseUrl = leafletParams.api_url ? leafletParams.api_url : '';
        this.center = [leafletParams.center_lat ? parseFloat(leafletParams.center_lat) : 46.1390931, leafletParams.center_lng ? parseFloat(leafletParams.center_lng) : 2];
        this.zoom = leafletParams.zoom && leafletParams.zoom !== 'auto' ? parseInt(leafletParams.zoom) : 6;
        this.activitiesBySlug = leafletParams.activities;
        this.icon = null;
        this.cluster = null;
        this.searchInBounds = null;
        this.markers = [];
        this.map = null;
        this.searchOnMove = true;
        this.isProgramaticZoom = false;
        this.resetInProgress = false;
        this.currentRequest = null;
        this.isLoadingAllPages = false;
        this.perPage = 100;
        this.lastParamsKey = '';
        this.totalExpected = 0;

        this.tempCluster = null;
        this.tempMarkers = [];

        this.init();
    }

    init() {
        this.initMap();
        this.initForm();
    }

    initMap() {
        if (typeof L !== 'undefined' && $('#map').length) {
            const mapOptions = {
                center: this.center,
                zoom: this.zoom,
                scrollWheelZoom: leafletParams.enable_scroll_wheel_zoom === true || leafletParams.enable_scroll_wheel_zoom === 'true'
            };

            this.icon = L.icon({
                iconUrl: leafletParams.template_url_path + '/img/marker.png',
                shadowUrl: null,
                iconSize: [40, 60],
                shadowSize: [0, 0]
            });

            this.map = L.map('map', mapOptions);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(this.map);

            if (this.searchOnMove) {
                const onMoveEnd = () => {
                    if (this.resetInProgress || this.isProgramaticZoom) {
                        setTimeout(() => { this.isProgramaticZoom = false; }, 150);
                        return;
                    }
                    this.searchInBounds = this.map.getBounds();
                    $('#form-search').find('input[name="point"]').val();
                    $('#form-search').trigger('submit');
                };

                const debouncedMoveEnd = (fn => {
                    let t;
                    return () => {
                        clearTimeout(t);
                        t = setTimeout(fn, 250);
                    };
                })(onMoveEnd);

                this.map.on('moveend', debouncedMoveEnd);

                this.map.on('popupopen popupclose', () => {
                    this.isProgramaticZoom = false;
                });
            }
        }
    }

    initForm() {
        $('#form-search').on('submit', () =>{ this.updateUrlFromForms(); });
        $('#form-name').on('submit',  () => { this.updateUrlFromForms(); });

        this.initLocationForm();
        this.initNameForm();

        this.restoreFormsFromQuery();

        if ($('#form-name').find('input[name="search"]').val()) {
            this.searchInBounds = null;
            this.isProgramaticZoom = true;
            $('#form-name').trigger('submit');
        } else if (
            $('#form-search').find('input[name="point"]').val() ||
            $('#form-search').find('input[name="location"]').val() ||
            $('#form-search').find('select[name="activities"]').val() !== 'all' ||
            $('#form-search').find('input[name="sap"]').is(':checked') ||
            $('#form-search').find('input[name="customer_types[]"]:checked').length
        ) {
            $('#form-search').trigger('submit');
        }

        $('#nav-tab-menu-location').find('.nav-link').on('click', () => {
            this.clearResults();
        });
    }

    initLocationForm() {
        let t;
        $('#form-search').on('submit', (e) => {
            e.preventDefault();

            let params = ['q=*', 'per_page=' + this.perPage];
            let filter_by = [];

            if (this.searchInBounds) {
                const northWest = this.searchInBounds.getNorthWest(),
                    northEast = this.searchInBounds.getNorthEast(),
                    southWest = this.searchInBounds.getSouthWest(),
                    southEast = this.searchInBounds.getSouthEast();
                filter_by.push('location:(' + northWest.lat+','+northWest.lng +','+ northEast.lat+','+northEast.lng +','+ southEast.lat+','+southEast.lng +','+ southWest.lat+','+southWest.lng + ')');
                const center = this.map.getCenter();
                params.push('sort_by=location(' + center.lat + ',' + center.lng + '):asc');
            } else {
                const point = $('#form-search').find('input[name="point"]').val();
                if (point) {
                    const qPoint = point.split(',').reverse().join(',');
                    filter_by.push('location:(' + qPoint + ',' + '25km)'); // default range
                    params.push('sort_by=location(' + qPoint + '):asc');
                }
            }

            const activity = $('#form-search').find('select[name="activities"]').val();
            if (activity && activity !== 'all') {
                const libelleActivity = this.activitiesBySlug[activity] ? this.activitiesBySlug[activity] : activity;
                filter_by.push('activities:' + libelleActivity);
            }

            const customerTypes = $('input[name="customer_types[]"]:checked')
                .map(function () { return '"' + String(this.value).replace(/"/g, '\\"') + '"'; })
                .get();

            if (customerTypes.length > 0) {
                filter_by.push('customer_types:=[' + customerTypes + ']');
            }

            const sap = $('#form-search').find('input[name="sap"]:checked').val();
            if (sap) {
                filter_by.push('sap:true');
            }

            if (filter_by.length > 0) {
                params.push('filter_by=' + encodeURIComponent(filter_by.join(' && ')));
            }

            this.querySearchAllPages(params);
        });

        $('#activities').on('change', () => {
            $('#form-search').trigger('submit');
        });

        $('.form-profil').off('change.ct').on('change.ct', 'input[name="customer_types[]"]', function(){
            clearTimeout(t); t=setTimeout(()=>$('#form-search').trigger('submit'), 0);
        });

        $('#form-search').find('input[name="sap"], input[name="point"]').on('change', () => {
            $('#form-search').trigger('submit');
        });

        $('#form-search').find('input[name="location"]').on('change', function () {
            this.searchInBounds = null;
            if (!$(this).val()) {
                $('#form-search').find('input[name="point"]').val('').trigger('change');
            }
        });

        $('#form-search').find('.btn-reset').on('click', (e) => {
            e.preventDefault();

            history.replaceState(null, '', location.pathname);

            $('#form-search')[0].reset();
            $('#form-search').find('input[name="location"]').val('');
            $('#form-search').find('input[name="point"]').val('');
            $('#form-search').find('select[name="activities"]').val('all');
            $('#form-search').find('input[name="sap"]').prop('checked', false);

            this.isProgramaticZoom = true;
            this.map.setView(this.center, this.zoom);

            this.clearResults();

            this.searchInBounds = null;

            setTimeout(() => {
                this.isProgramaticZoom = false;
                this.resetInProgress = false;
            }, 400);
        });
    }

    initNameForm() {
        $('#form-name').on('submit', (e) => {
            e.preventDefault();

            let params = ['q=*', 'per_page=' + this.perPage];

            const search = $('#form-name').find('input[name="search"]').val();
            if (search) {
                params = ['q=' + encodeURIComponent(search), 'per_page=' + this.perPage];
                params.push('query_by=company_name');
            }

            this.querySearchAllPages(params)
        });

        $('#form-name').find('input[name="search"]').on('input', () => {
            this.searchInBounds = null;
            if (this.nameInputTimeout) {
                clearTimeout(this.nameInputTimeout);
            }
            this.nameInputTimeout = setTimeout(() => {
                $('#form-name').trigger('submit');
            }, 400);
        });
    }

    clearResults() {
        this.isProgramaticZoom = true;

        // Annule la requête en cours
        if (this.currentRequest && this.currentRequest.abort) {
            try { this.currentRequest.abort(); } catch (e) {}
        }
        this.isLoadingAllPages = false;
        this.totalExpected = 0;

        // UI (ne pas masquer le bloc pour éviter le flash)
        const $results = $('#results');
        $results.find('h2').html('');
        $results.find('.list-companies').html('');
        $results.find('.icon-search-placeholder').removeClass('vhidden');

        // Retire tous les marqueurs de la carte
        if (this.markers && this.markers.length) {
            this.markers.forEach(m => {
                try { this.map.removeLayer(m); } catch(e) {}
            });
        }
        this.markers = [];

        // Retire et reset le cluster courant
        if (this.cluster) {
            try { this.map.removeLayer(this.cluster); } catch(e) {}
            try { this.cluster.clearLayers(); } catch(e) {}
        }
        this.cluster = null;

        // Nettoie le buffer temporaire
        if (this.tempCluster) {
            try { this.map.removeLayer(this.tempCluster); } catch(e) {}
            try { this.tempCluster.clearLayers(); } catch(e) {}
        }
        this.tempCluster = null;
        this.tempMarkers = [];
        this.searchInBounds = null;
    }

    querySearchAllPages(baseParams) {
        // Signature pour éviter d’ajouter des résultats d’une ancienne recherche
        this.lastParamsKey = baseParams.slice().sort().join('&');

        const $results = $('#results');
        const h = $results.height();
        $results.css('min-height', h + 'px');

        // $results.find('.icon-search-placeholder').removeClass('vhidden');
        $results.find('.list-companies').empty();

        if (this.tempCluster) {
            try { this.map.removeLayer(this.tempCluster); } catch(e) {}
        }
        this.tempCluster = L.markerClusterGroup();
        this.tempMarkers = [];

        // Variables de boucle
        let page = 1;
        let totalPages = null;
        let bounds = [];
        this.isLoadingAllPages = true;

        const loadPage = () => {
            // Si une requête précédente tourne, on l’annule
            if (this.currentRequest && this.currentRequest.abort) {
                try { this.currentRequest.abort(); } catch (e) {}
            }

            const params = baseParams.concat(['page=' + page]);
            const url = this.baseUrl + (params.length ? '?' + params.join('&') : '');

            this.currentRequest = $.ajax({
                url,
                type: 'GET',
                dataType: 'json',
                success: (data) => {
                    // Si entre-temps les params ont changé, on ignore
                    if (this.lastParamsKey !== baseParams.slice().sort().join('&')) {
                        return;
                    }

                    // Détermine totalPages à la première réponse
                    if (totalPages === null) {
                        const per = (data.request_params && data.request_params.per_page) ? data.request_params.per_page : this.perPage;
                        const found = (typeof data.found === 'number' ? data.found : 0);
                        this.totalExpected = found || 0;
                        totalPages = per > 0 ? Math.max(1, Math.ceil((found || 0) / per)) : 1;

                        // Met à jour le compteur mais ne cache pas le bloc
                        if (data.found > 0) {
                            $('#results').find('h2').html(data.found + ' résultat' + (data.found > 1 ? 's' : ''));
                        } else {
                            $('#results').find('h2').html(data.found + ' résultat');
                        }
                    }

                    // Ajoute les marqueurs de cette page
                    if (data.hits && Array.isArray(data.hits)) {
                        $('#results').find('.icon-search-placeholder').addClass('vhidden');

                        data.hits.forEach((hit) => {
                            if (!hit.document || !hit.document.wp_id || !hit.document.location || !Array.isArray(hit.document.location) && hit.document.location.length === 2) {
                                return;
                            }

                            const latlng = [
                                hit.document.location[0],
                                hit.document.location[1]
                            ];

                            const leafletPopup = L.popup()
                                .setContent(this.getContentLeafletPopup(hit.document));

                            const leafletMarker = L.marker(L.latLng(latlng[0], latlng[1]), {
                                icon: this.icon
                            });

                            leafletMarker
                                .bindPopup(leafletPopup)
                                .openPopup()
                                .on('click', () => {
                                    this.isProgramaticZoom = true;
                                });

                            this.tempCluster.addLayer(leafletMarker);
                            this.tempMarkers.push(leafletMarker);

                            bounds.push(latlng);
                        });
                    }

                    page++;
                    if (this.isLoadingAllPages && page <= totalPages) {
                        loadPage();
                    } else {
                        if (this.cluster) {
                            try { this.map.removeLayer(this.cluster); } catch(e) {}
                        }
                        this.cluster = this.tempCluster;
                        this.map.addLayer(this.cluster);
                        this.markers = this.tempMarkers;

                        // Reset buffer
                        this.tempCluster = null;
                        this.tempMarkers = [];

                        this.isLoadingAllPages = false;
                        this.isProgramaticZoom = false;

                        $('#results').css('min-height', '');

                        // Fit bounds uniquement après la première recherche (ou si besoin)
                        if (!this.searchInBounds && bounds.length) {
                            this.isProgramaticZoom = true;
                            this.map.fitBounds(bounds, { padding: [30, 30] });
                        }

                        // if (!this.totalExpected) {
                        //     $('#results').find('.icon-search-placeholder').removeClass('vhidden');
                        // } else {
                        //     $('#results').find('.icon-search-placeholder').addClass('vhidden');
                        // }
                    }
                },
                error: (xhr, status, error) => {
                    if (status === 'abort') return;
                    this.isLoadingAllPages = false;
                    this.isProgramaticZoom = false;
                }
            });
        };

        loadPage();
    }

    getContentLeafletPopup(document) {
        const name = this.escapeHtml(document.company_name);
        const address = this.escapeHtml(document.full_address);
        const phone = this.escapeHtml(document.phone);
        const telHref = document.phone ? `tel:${String(document.phone).replace(/\s+/g, '')}` : '#';
        const link = this.escapeHtml('/localiser-un-paysagiste/' + document.slug);
        const activities = Array.isArray(document.activities) ? document.activities : [];

        const bgImg = `<div class="bg-img"></div>`;

        const logoUrl = this.escapeHtml(document.logo || `${leafletParams.template_url_path}/img/avatar-defaut_mastructure.gif`);
        const logoAlt = `Logo ${name}`;

        const activitiesText = (() => {
            const items = activities
                .map(a => this.escapeHtml(a && (a.name || a)))
                .filter(Boolean);

            if (items.length <= 5) {
                return items.join(", ");
            }

            const firstFive = items.slice(0, 5).join(", ");
            return `${firstFive} ... Consultez la fiche pour voir toutes les activités de l’entreprise`;
        })();

        const addressHtml = address ? this.nl2br(address) : "";

        const safeLink = this.collapseSlashes(`${leafletParams.site_url}${this.escapeHtml(link || '#')}`);

        const card = `
            <article class="result-row w-100" data-id="firm_{{ loop.index }}">
                <img class="result-logo" src="${logoUrl}" alt="${logoAlt}">
                <div class="result-body">
                    <h3 class="result-title">${name}</h3>
                    <div class="result-meta d-flex flex-column">
                        ${address ? `<span><i class="icon-map-pin mr-1"></i> ${address}</span>` : ``}
                        ${phone ? `<span><i class="icon-tel mr-1"></i>${phone}</span>` : ``}
                        ${activities.length > 0 ? `<span class="activites mt-1 d-block d-md-inline"><i class="icon-leaf mr-1"></i> ${activitiesText}</span>` : ``}
                    </div>
                    <a href="${safeLink}" class="stretched-link"></a>
                </div>
            </article>
        `.trim();

        if ($('#results')) {
            $('#results').find('.list-companies').append(card);
        }

        return `
        <div class="locationinfo">
            <div id="popup">
              <h2>${name}</h2>
              <p class="storycontent">
                ${address ? `<span>${addressHtml}</span><br>` : ``}
                ${phone ? `<a href="${telHref}" class="phone">${phone}</a><br>` : ``}
              </p>
              <a target="_parent" href="${safeLink}" class="btn btn-pill btn-primary text-white">
                Voir l'entreprise
                <i class="icon-landscaper ml-3"></i>
              </a>
            </div>
        </div>
        `.trim();
    }

    escapeHtml(str = "") {
        return String(str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    nl2br(str = "") {
        return String(str).replace(/\r\n|\r|\n/g, "<br>");
    }

    collapseSlashes(url) {
        return String(url).replace(/(^\w+:)\/+/, '$1//').replace(/([^:])\/{2,}/g, '$1/');
    }

    updateUrlFromForms() {
        const params = new URLSearchParams();

        // Formulaire localisation
        const $fs = $('#form-search');
        if ($fs.length) {
            const point = $fs.find('input[name="point"]').val();
            const location = $fs.find('input[name="location"]').val();
            const activities = $fs.find('select[name="activities"]').val();
            const sap = $fs.find('input[name="sap"]').is(':checked');
            const customerTypes = $fs.find('input[name="customer_types[]"]:checked')
                .map(function(){ return this.value; }).get();

            if (point) params.set('point', point);
            if (location) params.set('location', location);
            if (activities && activities !== 'all') params.set('activities', activities);
            if (sap) params.set('sap', '1');
            if (customerTypes.length) params.set('customer_types', customerTypes.join(','));
        }

        // Formulaire nom
        const $fn = $('#form-name');
        if ($fn.length) {
            const search = $fn.find('input[name="search"]').val();
            if (search) params.set('search', search);
        }

        const newUrl = `${location.pathname}?${params.toString()}`;
        history.replaceState(null, '', newUrl);
    }

    restoreFormsFromQuery() {
        const qs = new URLSearchParams(window.location.search);

        // Formulaire localisation (#form-search)
        const $fs = $('#form-search');
        if ($fs.length) {
            if (qs.has('location')) $fs.find('input[name="location"]').val(qs.get('location'));
            if (qs.has('point')) $fs.find('input[name="point"]').val(qs.get('point'));
            if (qs.has('activities')) $fs.find('select[name="activities"]').val(qs.get('activities'));
            if (qs.has('sap')) $fs.find('input[name="sap"]').prop('checked', qs.get('sap') === '1' || qs.get('sap') === 'true');

            if (qs.has('customer_types')) {
                const set = new Set(qs.get('customer_types').split(',').map(s => s.trim()).filter(Boolean));
                $fs.find('input[name="customer_types[]"]').each(function () {
                    $(this).prop('checked', set.has(this.value));
                });
            }
        }

        // Formulaire nom (#form-name)
        const $fn = $('#form-name');
        if ($fn.length && qs.has('search')) {
            $fn.find('input[name="search"]').val(qs.get('search'));
        }
    }
}
